export default __webpack_public_path__ + "static/media/855.0be6362f.gif";